import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Tabs,
  Form,
  InputGroup,
  Button,
  Tab,
  Nav,
  Dropdown,
} from "react-bootstrap";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

import "./App.css";
import { Gpt } from "./Gpt";
import { Dalle } from "./Dalle";
import { MusicGen } from "./MusicGen";
import { MoviePosterEditor } from "./MoviePosterEditor";
import { ResetAllButton } from "./ResetAllButton";
import { Slideshow } from "./Slideshow";
import { VoiceCloneCreatorOptions } from "./voice_clone_and_synthesis";

import FormControl from "react-bootstrap/FormControl";

function App() {

  const [errorMessage, setErrorMessage] = React.useState(null);
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [authenticationFailed, setAuthenticationFailed] = React.useState(false);
  const [openaiApiKeyGpt4, setOpenaiApiKeyGpt4] = React.useState('');
  const [gptModel, setGptModel] = React.useState('');
  const [imageModel, setImageModel] = React.useState('');
  const [openaiApiKeyDalle3, setOpenaiApiKeyDalle3] = React.useState('');
  const [nodeId, setNodeId] = React.useState(-1);
  const [nodeIdDone, setNodeIdDone] = React.useState(false);
  const [workshopId, setWorkshopId] = React.useState("unknown");
  const [allWorkshopIds, setAllWorkshopIds] = React.useState([]);
  const [readyForPoster, setReadyForPosterHelper] = React.useState(false);
  const [elevenlabsKeys, setElevenlabsKeys] = React.useState([]);
  const [voiceOver, setVoiceOver] = React.useState('');
  const [elevatorPitch, setElevatorPitch] = React.useState('');
  const [imageGenerationStarted, setImageGenerationStartedHelper] = React.useState(false);

  const [activeTab, setActiveTab] = useState('gpt');
  const [isMobile, setIsMobile] = useState(false);

  const fabricCanvasRef = useRef(null);

  const passwordRef = useRef(null);
  
  // Separate refs for desktop and mobile layouts
  const nodeTypeRefDesktop = useRef(null);
  const nodeIdRefDesktop = useRef(null);
  const workshopNameRefDesktop = useRef(null);
  const nodeTypeRefMobile = useRef(null);
  const nodeIdRefMobile = useRef(null);
  const workshopNameRefMobile = useRef(null);

  const setReadyForPoster = (value) => {
    localStorage.setItem("ready-for-poster", JSON.stringify(value));
    setReadyForPosterHelper(value);
  }

  const setImageGenerationStarted = (value) => {
    localStorage.setItem("image-generation-started", JSON.stringify(value));
    setImageGenerationStartedHelper(value);
  }

  const getTabTitle = (tabKey) => {
    const tabTitles = {
      'gpt': 'Text Generation',
      'dalle': 'Image Generation', 
      'poster': 'Movie Poster',
      'voice-cloning': 'Voice Generation'
    };
    return tabTitles[tabKey] || 'Text Generation';
  }

  useEffect(() => {
    const storedPassword = localStorage.getItem("frontend-password");

    const storedNode = JSON.parse(localStorage.getItem("nn-node"));
    if (storedNode) {
      setNodeId(storedNode);
      setNodeIdDone(true);
    }

    const storedWorkshopId = JSON.parse(localStorage.getItem("workshop-id"));
    if (storedWorkshopId) {
      setWorkshopId(storedWorkshopId);
    }

    const storedReadyForPoster = JSON.parse(localStorage.getItem("ready-for-poster"));
    if (storedReadyForPoster) {
      setReadyForPoster(storedReadyForPoster);
    }

    const storedImageGenerationStarted = JSON.parse(localStorage.getItem("image-generation-started"));
    if (storedImageGenerationStarted) {
      setImageGenerationStarted(storedImageGenerationStarted);
    }

    if (storedPassword) {
      authenticate(storedPassword);
    }

    // Mobile detection
    const checkMobile = () => {
      // Simple threshold: mobile view when screen width is less than 1250px
      setIsMobile(window.innerWidth < 1250);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Effect to handle tab line color change
  useEffect(() => {
    const navTabs = document.querySelector('.blue-tabs .nav-tabs');
    if (navTabs) {
      if (activeTab) {
        navTabs.classList.add('active-line');
      } else {
        navTabs.classList.remove('active-line');
      }
    }
  }, [activeTab]);

  function resetAll() {
    localStorage.setItem("gpt-messages", JSON.stringify([]));
    localStorage.setItem("dalle-outputs", JSON.stringify([]));
    localStorage.setItem("musicgen-urls", JSON.stringify([]));
    localStorage.setItem("workshop-id", JSON.stringify(null));
    localStorage.setItem("nn-node", JSON.stringify(null));
    localStorage.setItem("slide", JSON.stringify(null));
    localStorage.setItem("ready-for-poster", JSON.stringify(false));
    localStorage.setItem("image-generation-started", JSON.stringify(false));
    localStorage.setItem("voices", JSON.stringify([]));
    localStorage.setItem("synth", JSON.stringify([]));
    window.location.reload();
  }

  function authenticate(passwordValue) {

    fetch("/authenticate_frontend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ password: passwordValue }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.authenticated) {
          console.log("Authenticated successfully");
          setIsAuthenticated(true);
          setAuthenticationFailed(false);

          setOpenaiApiKeyGpt4(data.openai_api_key_gpt4)
          setOpenaiApiKeyDalle3(data.openai_api_key_dalle3)

          setGptModel(data.gpt_model)
          setImageModel(data.image_model)

          setAllWorkshopIds(data.workshop_ids);
          setElevenlabsKeys(data.elevenlabs_keys);

          // Save password in local storage
          localStorage.setItem("frontend-password", passwordValue);

        } else {
          console.log("Authentication failed");
          setIsAuthenticated(false);
          setAuthenticationFailed(true);
        }
      })
      .catch((error) => {
        console.error(
          "There was an error with the authentication request:",
          error
        );
      });
  }

  let errorMessageToast = <></>;
  if (errorMessage) {
    errorMessageToast = (
      <ToastContainer position="bottom-center" containerPosition="fixed" style={{ zIndex: 99999 }}>
        <Toast
          show={errorMessage != null}
          onClose={() => setErrorMessage(null)}
          style={{ marginBottom: "90px", backgroundColor: "#dddddd", zIndex: 99999 }}
        >
          <Toast.Header>
            <strong className="me-auto" style={{ fontSize: 'large' }}>Error</strong>
          </Toast.Header>
          <Toast.Body style={{ textAlign: "center" }}>
            {errorMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    );
  }

  let failedText = <></>
  if (authenticationFailed) {
    failedText = <><br /><span style={{ color: 'red' }}>Authentication failed</span></>
  }

  if (!isAuthenticated) {
    return (
      <div style={{ 
        backgroundColor: '#f5f5f5', 
        minHeight: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        overflow: 'auto'
      }}>
        {/* Orange Header */}
        <div style={{ 
          backgroundColor: '#f05f40', 
          padding: '5px 0px', 
          width: '100%',
          position: 'relative',
          zIndex: 10
        }}>
          <Container fluid>
            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left', paddingLeft: '0px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span style={{ color: 'white', fontSize: '10px', fontWeight: 'bold', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif' }}>
                  STAGE ONE EDUCATION
                </span>
                <span style={{ color: 'white', fontSize: '8px', fontWeight: 'bold', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif' }}>
                  Artificial Intelligence Workshop
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px', marginRight: '8px' }}>
                <div style={{ width: '1px', height: '28px', backgroundColor: 'white', opacity: '0.7' }}></div>
              </div>
              <span style={{ color: 'white', fontSize: '24px', fontWeight: 'bold', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif' }}>
                Film Studio
              </span>
            </div>
          </Container>
        </div>

        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          paddingTop: '50px',
          position: 'relative',
          zIndex: 2
        }}>
          <div style={{
            width: '60%',
            maxWidth: '800px',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <Container className="mt-4">
              <Row className="mb-4">
                <Col>
                  <h2>Enter today's password</h2>
                  <br />
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      const passwordValue = passwordRef.current.value;
                      authenticate(passwordValue);
                    }}
                  >
                    <InputGroup>
                      <FormControl
                        type="password"
                        placeholder=""
                        aria-label="Password"
                        aria-describedby="password-addon"
                        ref={passwordRef}
                        autoFocus
                        key="passbox"
                        style={{ fontSize: '150%' }}
                      />
                      <Button type="submit">Submit</Button>
                    </InputGroup>
                  </Form>
                  {failedText}
                </Col>
              </Row>
              {errorMessageToast}
            </Container>
          </div>
        </div>

        {/* Copyright Footer */}
        <div style={{
          position: 'fixed',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#999999',
          fontSize: '12px',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 'normal',
          zIndex: 9999
        }}>
          © 2025 Stage One Education, LLC
        </div>

        {/* Gear Icon - Bottom Left */}
        <div 
          className="gear-icon" 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const isDevelopment = window.location.hostname === 'localhost' && window.location.port === '3000';
            const manageUrl = isDevelopment ? 'http://localhost:5000/manage-servers/' : '/manage-servers/';
            console.log('Gear icon clicked - opening in new tab:', manageUrl);
            window.open(manageUrl, '_blank', 'noopener,noreferrer');
          }}
          style={{ 
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            fontSize: '20px',
            color: 'white',
            cursor: 'pointer',
            zIndex: 1000,
            opacity: 0.1
          }}
        >
          <FontAwesomeIcon icon={faCog} />
        </div>
      </div>
    )
  }

  // Check for slideshow route before node selection
  if (window.location.pathname === "/slideshow") {
    return (
      <Slideshow />
    );
  }

  if (!nodeIdDone) {
    return (
      <div className="intro-page-background">
        {/* Orange Header */}
        <div style={{ 
          backgroundColor: '#f05f40', 
          padding: '5px 0px', 
          width: '100%',
          position: 'relative',
          zIndex: 10
        }}>
          <Container fluid>
            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left', paddingLeft: '0px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span style={{ color: 'white', fontSize: '10px', fontWeight: 'bold', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif' }}>
                  STAGE ONE EDUCATION
                </span>
                <span style={{ color: 'white', fontSize: '8px', fontWeight: 'bold', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif' }}>
                  Artificial Intelligence Workshop
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px', marginRight: '8px' }}>
                <div style={{ width: '1px', height: '28px', backgroundColor: 'white', opacity: '0.7' }}></div>
              </div>
              <span style={{ color: 'white', fontSize: '24px', fontWeight: 'bold', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif' }}>
                Film Studio
              </span>
            </div>
          </Container>
        </div>

        <div className="centered-content">
          <div className="main-content-container">
            <Container className="mt-4">
              <Row className="mb-4">
                <Col>
                  <h2>My neural network node was:</h2>
                  <p>(the node you had during the paper exercise)</p>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      // Use appropriate refs based on current layout
                      const isCurrentlyMobile = window.innerWidth < 1250;
                      
                      let workshopId, nodeval, nodetype;
                      
                      if (isCurrentlyMobile) {
                        workshopId = workshopNameRefMobile.current.value;
                        nodeval = nodeIdRefMobile.current.value;
                        nodetype = nodeTypeRefMobile.current.value;
                      } else {
                        workshopId = workshopNameRefDesktop.current.value;
                        nodeval = nodeIdRefDesktop.current.value;
                        nodetype = nodeTypeRefDesktop.current.value;
                      }
                      
                      if (workshopId === "" || nodeval === "" || nodetype === "") {
                        setErrorMessage("Select a workshop ID and enter a node number.");
                        return;
                      }
                      setWorkshopId(workshopId);
                      setNodeId(nodetype + nodeval);
                      setNodeIdDone(true);
                      localStorage.setItem("nn-node", JSON.stringify(nodetype + nodeval));
                      localStorage.setItem("workshop-id", JSON.stringify(workshopId));
                    }}
                  >
                    {/* Desktop view - horizontal layout */}
                    <div className="d-none d-lg-block">
                      <InputGroup>
                        <Form.Select aria-label="Workshop select"
                          style={{ maxWidth: '600px', marginRight: '10px' }}
                          ref={workshopNameRefDesktop}>
                          <option value="">-- Select a workshop --</option>
                          {allWorkshopIds.map((id) => (
                            <option key={id} value={id}>
                              {id}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Select aria-label="Node type select"
                          style={{ maxWidth: '200px', marginRight: '10px' }}
                          ref={nodeTypeRefDesktop}>
                          <option value="B">B</option>
                          <option value="C">C</option>
                        </Form.Select>
                        <Form.Control
                          type="number"
                          placeholder="Enter number"
                          min="0"
                          max="100"
                          style={{ maxWidth: '200px' }}
                          ref={nodeIdRefDesktop}
                        />
                        <Button type="submit">Go</Button>
                      </InputGroup>
                    </div>
                    
                    {/* Mobile view - vertical layout */}
                    <div className="d-lg-none">
                      <div className="mb-3">
                        <Form.Select aria-label="Workshop select"
                          style={{ width: '100%' }}
                          ref={workshopNameRefMobile}>
                          <option value="">-- Select a workshop --</option>
                          {allWorkshopIds.map((id) => (
                            <option key={id} value={id}>
                              {id}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                      <div className="mb-3">
                        <Form.Select aria-label="Node type select"
                          style={{ width: '100%' }}
                          ref={nodeTypeRefMobile}>
                          <option value="B">B</option>
                          <option value="C">C</option>
                        </Form.Select>
                      </div>
                      <div className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="Enter number"
                          min="0"
                          max="100"
                          style={{ width: '100%' }}
                          ref={nodeIdRefMobile}
                        />
                      </div>
                      <div className="mb-3">
                        <Button type="submit" className="w-100">Go</Button>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
              {errorMessageToast}
            </Container>
          </div>
        </div>

        {/* Bottom Right Text Box */}
        <div className="film-posters-text-box" style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: 'white',
          border: '2px solid gray',
          borderRadius: '50px',
          padding: '5px 5px',
          zIndex: 1000,
          width: 'auto',
          minWidth: 'fit-content'
        }}>
          <div style={{
            color: 'gray',
            fontFamily: 'Roboto, sans-serif',
            fontSize: '10px',
            fontWeight: 'bold',
            lineHeight: '1.3',
            textAlign: 'center',
            whiteSpace: 'nowrap'
          }}>
            Film posters were created by participants using leading AI models
          </div>
        </div>

        {/* Copyright Footer */}
        <div style={{
          position: 'fixed',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#999999',
          fontSize: '12px',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 'normal',
          zIndex: 9999
        }}>
          © 2025 Stage One Education, LLC
        </div>

        {/* Gear Icon - Bottom Left */}
        <div 
          className="gear-icon" 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const isDevelopment = window.location.hostname === 'localhost' && window.location.port === '3000';
            const manageUrl = isDevelopment ? 'http://localhost:5000/manage-servers/' : '/manage-servers/';
            console.log('Gear icon clicked - opening in new tab:', manageUrl);
            window.open(manageUrl, '_blank', 'noopener,noreferrer');
          }}
          style={{ 
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            fontSize: '20px',
            color: 'white',
            cursor: 'pointer',
            zIndex: 1000,
            opacity: 0.1
          }}
        >
          <FontAwesomeIcon icon={faCog} />
        </div>
      </div>
    )
  }

  let gptNumber = '4';
  if (gptModel.includes('gpt-3.5')) {
    gptNumber = '3.5'
  }

  return (
    <>
      {/* Sticky Header Section */}
      <div className="sticky-header">
        <Container>
          <Row className="mb-0" style={{ paddingTop: '8px' }}>
            <Col>
              <div className={`orange-header-container ${isMobile ? 'mobile-header' : ''}`} style={{ 
                backgroundColor: '#f05f40', 
                padding: '0 0.4rem', 
                borderRadius: '0.4rem 0.4rem 0 0',
                marginBottom: '0',
                height: isMobile ? '4rem' : '2.2rem',
                display: 'flex',
                alignItems: 'center'
              }}>
                {isMobile ? (
                  <div className="mobile-header-layout" style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
                    {/* Line 1: Left-justified heading, Right-justified node/workshop */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '0.5rem' }}>
                      <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <span style={{ color: 'white', fontSize: '0.65rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                            STAGE ONE EDUCATION
                          </span>
                          <span style={{ color: 'white', fontSize: '0.5rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                            Artificial Intelligence Workshop
                          </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '0.3rem', marginRight: '0.3rem' }}>
                          <div style={{ width: '1px', height: '1.2rem', backgroundColor: 'white', opacity: '0.7' }}></div>
                        </div>
                        <span style={{ color: 'white', fontSize: '1.2rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                          Film Studio
                        </span>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                        <span className="node-text" style={{ color: 'white', marginTop: '0px', whiteSpace: 'nowrap', marginBottom: '2px', fontSize: '0.7rem' }}>{nodeId}</span>
                        <span className="workshop-text" style={{ color: 'white', fontSize: '0.5rem', fontWeight: 'normal', fontFamily: 'Roboto, sans-serif', lineHeight: '1', marginTop: '0px' }}>{workshopId}</span>
                      </div>
                    </div>
                    {/* Line 2: Centered dropdown */}
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                      <Dropdown className="mobile-dropdown">
                        <Dropdown.Toggle variant="outline-light" size="sm" className="mobile-dropdown-toggle">
                          {getTabTitle(activeTab)}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="mobile-dropdown-menu">
                          <Dropdown.Item 
                            active={activeTab === 'gpt'} 
                            onClick={() => setActiveTab('gpt')}
                            className="mobile-dropdown-item"
                          >
                            Text Generation
                          </Dropdown.Item>
                          <Dropdown.Item 
                            active={activeTab === 'dalle'} 
                            onClick={() => setActiveTab('dalle')}
                            className="mobile-dropdown-item"
                          >
                            Image Generation
                          </Dropdown.Item>
                          <Dropdown.Item 
                            active={activeTab === 'poster'} 
                            onClick={() => setActiveTab('poster')}
                            className="mobile-dropdown-item"
                          >
                            Movie Poster
                          </Dropdown.Item>
                          <Dropdown.Item 
                            active={activeTab === 'voice-cloning'} 
                            onClick={() => setActiveTab('voice-cloning')}
                            className="mobile-dropdown-item"
                          >
                            Voice Generation
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <span style={{ color: 'white', fontSize: '0.65rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                          STAGE ONE EDUCATION
                        </span>
                        <span style={{ color: 'white', fontSize: '0.5rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                          Artificial Intelligence Workshop
                        </span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginLeft: '0.3rem', marginRight: '0.3rem' }}>
                        <div style={{ width: '1px', height: '1.2rem', backgroundColor: 'white', opacity: '0.7' }}></div>
                      </div>
                      <span style={{ color: 'white', fontSize: '1.4rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                        Film Studio
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', height: '100%', marginBottom: '0px', paddingBottom: '0px' }}>
                      <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="inline-tabs"
                        style={{ margin: '0', padding: '0', marginBottom: '0px', transform: 'translateY(0.3rem)' }}
                      >
                        <Tab eventKey="gpt" title={<>Text Generation</>}></Tab>
                        <Tab eventKey="dalle" title={<>Image Generation</>}></Tab>
                        <Tab eventKey="poster" title={<>Movie Poster</>}></Tab>
                        <Tab eventKey="voice-cloning" title={<>Voice Generation</>}></Tab>
                      </Tabs>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end', height: '100%', paddingBottom: '0.2rem' }}>
                      <span className="node-text" style={{ color: 'white', marginTop: '0px', whiteSpace: 'nowrap', marginBottom: '2px' }}>{nodeId}</span>
                      <span className="workshop-text" style={{ color: 'white', fontSize: '0.5rem', fontWeight: 'normal', fontFamily: 'Roboto, sans-serif', lineHeight: '1', marginTop: '0px' }}>{workshopId}</span>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Main Content Section */}
      <Container>
        <Row className="mb-4" style={{ marginTop: '0px' }}>
          <Col>
            <div className="white-content-area" style={{ backgroundColor: 'white', padding: '10px 20px 20px 20px', borderRadius: '0px' }}>
                  <div style={{ display: activeTab === 'gpt' ? 'block' : 'none' }}>
                    <Gpt
                      openaiApiKey={openaiApiKeyGpt4}
                      gptModel={gptModel}
                      setErrorMessage={setErrorMessage}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      setVoiceOver={setVoiceOver}
                      setElevatorPitch={setElevatorPitch}
                      imageGenerationStarted={imageGenerationStarted}
                    />
                  </div>
                  <div style={{ display: activeTab === 'dalle' ? 'block' : 'none' }}>
                    <Dalle
                      openaiApiKey={openaiApiKeyDalle3}
                      setErrorMessage={setErrorMessage}
                      activeTab={activeTab}
                      nodeId={nodeId}
                      imageModel={imageModel}
                      fabricCanvasRef={fabricCanvasRef}
                      switchTab={(tab) => setActiveTab(tab)}
                      readyForPoster={readyForPoster}
                      setReadyForPoster={setReadyForPoster}
                      setImageGenerationStarted={setImageGenerationStarted}
                    />
                  </div>
                  <div style={{ display: activeTab === 'poster' ? 'block' : 'none' }}>
                    <MoviePosterEditor
                      canvasRef={fabricCanvasRef}
                      workshopId={workshopId}
                      readyForPoster={readyForPoster}
                      activeTab={activeTab}
                    />
                  </div>
                  <div style={{ display: activeTab === 'voice-cloning' ? 'block' : 'none' }}>
                    <VoiceCloneCreatorOptions
                      elevenlabsKeys={elevenlabsKeys}
                      voiceOver={voiceOver}
                      elevatorPitch={elevatorPitch}
                      activeTab={activeTab}
                      workshopId={workshopId}
                    />
                  </div>
                </div>
            
            {/* Bottom Orange Box with Tabs */}
            <div className="bottom-tabs-container" style={{ 
              backgroundColor: '#f05f40', 
              padding: '0.4rem 0.4rem 0 0.4rem', 
              borderRadius: '0 0 0.4rem 0.4rem',
              marginBottom: '1rem',
              height: '2.2rem',
              position: 'relative',
              zIndex: 2
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
                <div className="spacer-left" style={{ display: 'flex', alignItems: 'center', textAlign: 'left', backgroundColor: '#f05f40', padding: '0.3rem', height: '1.4rem' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ color: 'transparent', fontSize: '0.7rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                      STAGE ONE EDUCATION
                    </span>
                    <span style={{ color: 'transparent', fontSize: '0.6rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                      Artificial Intelligence Workshop
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: '0.4rem', marginRight: '0.4rem' }}>
                    <div style={{ width: '1px', height: '1.4rem', backgroundColor: 'transparent', opacity: '0' }}></div>
                  </div>
                  <span style={{ color: 'transparent', fontSize: '1.2rem', fontWeight: 'bold', lineHeight: '1.2' }}>
                    Film Studio
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flex: 1, height: '100%', marginBottom: '0px', position: 'relative', zIndex: 1 }}>
                  {isMobile ? (
                    <Dropdown className="mobile-dropdown-bottom">
                      <Dropdown.Toggle variant="outline-light" size="sm" className="mobile-dropdown-toggle-bottom">
                        {getTabTitle(activeTab)}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="mobile-dropdown-menu-bottom">
                        <Dropdown.Item 
                          active={activeTab === 'gpt'} 
                          onClick={() => setActiveTab('gpt')}
                          className="mobile-dropdown-item"
                        >
                          Text Generation
                        </Dropdown.Item>
                        <Dropdown.Item 
                          active={activeTab === 'dalle'} 
                          onClick={() => setActiveTab('dalle')}
                          className="mobile-dropdown-item"
                        >
                          Image Generation
                        </Dropdown.Item>
                        <Dropdown.Item 
                          active={activeTab === 'poster'} 
                          onClick={() => setActiveTab('poster')}
                          className="mobile-dropdown-item"
                        >
                          Movie Poster
                        </Dropdown.Item>
                        <Dropdown.Item 
                          active={activeTab === 'voice-cloning'} 
                          onClick={() => setActiveTab('voice-cloning')}
                          className="mobile-dropdown-item"
                        >
                          Voice Generation
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <Tabs
                      activeKey={activeTab}
                      onSelect={(k) => setActiveTab(k)}
                      className="bottom-tabs"
                      style={{ 
                        margin: '0', 
                        padding: '0', 
                        marginBottom: '0px',
                        transform: 'translateY(-0.4rem)',
                        '--bs-border-radius': '0.4rem',
                        '--bs-border-top-left-radius': '0',
                        '--bs-border-top-right-radius': '0',
                        '--bs-border-bottom-left-radius': '0.4rem',
                        '--bs-border-bottom-right-radius': '0.4rem'
                      }}
                    >
                      <Tab eventKey="gpt" title={<>Text Generation</>}></Tab>
                      <Tab eventKey="dalle" title={<>Image Generation</>}></Tab>
                      <Tab eventKey="poster" title={<>Movie Poster</>}></Tab>
                      <Tab eventKey="voice-cloning" title={<>Voice Generation</>}></Tab>
                    </Tabs>
                  )}
                </div>
                <div className="spacer-right" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end', backgroundColor: '#f05f40', padding: '0.3rem', height: '1.4rem', paddingBottom: '0.1rem' }}>
                  <span className="node-text" style={{ color: 'transparent', marginTop: '0px', whiteSpace: 'nowrap', marginBottom: '2px' }}>{nodeId}</span>
                  <span className="workshop-text" style={{ color: 'transparent', fontSize: '0.5rem', fontWeight: 'normal', fontFamily: 'Roboto, sans-serif', lineHeight: '1', marginTop: '0px' }}>{workshopId}</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {errorMessageToast}
        
        {/* Copyright, Reset All Button, and Gear Icon - Second to Last Line */}
        <div className="copyright-button-container" style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-end',
          marginTop: '5px',
          marginBottom: '0px',
          paddingBottom: '0px'
        }}>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
            <div 
              className="gear-icon" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // In development, navigate to Flask server directly
                // In production, both apps are served from the same domain
                const isDevelopment = window.location.hostname === 'localhost' && window.location.port === '3000';
                const manageUrl = isDevelopment ? 'http://localhost:5000/manage-servers/' : '/manage-servers/';
                console.log('Gear icon clicked - opening in new tab:', manageUrl);
                window.open(manageUrl, '_blank', 'noopener,noreferrer');
              }}
              style={{ 
                position: 'static', 
                right: 'auto', 
                top: 'auto',
                fontSize: '16px',
                color: 'white',
                textDecoration: 'none',
                cursor: 'pointer'
              }}
            >
              <FontAwesomeIcon icon={faCog} />
            </div>
          </div>
          <div className="copyright-text" style={{ margin: 0 }}>
            © 2025 Stage One Education, LLC
          </div>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <ResetAllButton callback={resetAll} />
          </div>
        </div>
        <hr style={{ margin: '10px 0', borderColor: '#ddd' }} />
      </Container>

    </>
  );
}

export default App;
